import moment from 'moment-timezone'

const SERVER_TZ = 'Asia/Tokyo'
const JOIN_WINDOW_SECONDS_BEFORE_START = 600

export function parseServerTime (serverTimeStr) {
  return moment.tz(serverTimeStr, SERVER_TZ)
}

export function msUntilServerTime (serverTimeStr) {
  if (!serverTimeStr) return 0
  const diff = parseServerTime(serverTimeStr).valueOf() - Date.now()
  return diff > 0 ? diff : 0
}

function fallbackCanJoinFromClientTime (meeting) {
  if (!meeting.start_at || !meeting.end_at) return false
  return moment().diff(meeting.start_at, 'seconds') > -JOIN_WINDOW_SECONDS_BEFORE_START &&
    moment().isBefore(meeting.end_at)
}

export function isJoinButtonEnabled (meeting) {
  if (!meeting || !meeting.start_at) return false
  if (typeof meeting.can_join === 'boolean') return meeting.can_join
  return fallbackCanJoinFromClientTime(meeting)
}

export function scheduleJoinRefresh (meeting, onRefresh) {
  const timerIds = []

  const scheduleAt = (serverTimeStr) => {
    const delay = msUntilServerTime(serverTimeStr)
    if (delay > 0) {
      timerIds.push(setTimeout(onRefresh, delay))
    }
  }

  scheduleAt(meeting.join_available_from)
  scheduleAt(meeting.join_available_until)

  return () => {
    timerIds.forEach(id => clearTimeout(id))
  }
}



// WEBPACK FOOTER //
// ./src/utils/joinWindow.js